import { render, staticRenderFns } from "./Byn2Import.vue?vue&type=template&id=70c85826&scoped=true"
import script from "./Byn2Import.vue?vue&type=script&lang=js"
export * from "./Byn2Import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c85826",
  null
  
)

export default component.exports